import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';
import { roleGuard } from './guards/role-guard';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'forgot',
    loadComponent: () => import('./pages/login/forgot/forgot.page').then( m => m.ForgotPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/login/reset-password/reset-password.page').then( m => m.ResetPasswordPage)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente', 'Public'] }
  },
  {
    path: 'dashboard-preventa',
    loadComponent: () => import('./pages/preventa/dashboard-preventa/dashboard-preventa.page').then( m => m.DashboardPreventaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'crear-preventa',
    loadComponent: () => import('./pages/preventa/crear-preventa/crear-preventa.page').then( m => m.CrearPreventaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-preventa',
    loadComponent: () => import('./pages/preventa/editar-preventa/editar-preventa.page').then( m => m.EditarPreventaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'detalles-preventa',
    loadComponent: () => import('./pages/preventa/detalles-preventa/detalles-preventa.page').then( m => m.DetallesPreventaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'dashboard-venta',
    loadComponent: () => import('./pages/venta/dashboard-venta/dashboard-venta.page').then( m => m.DashboardVentaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-venta',
    loadComponent: () => import('./pages/venta/editar-venta/editar-venta.page').then( m => m.EditarVentaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'detalles-venta',
    loadComponent: () => import('./pages/venta/detalles-venta/detalles-venta.page').then( m => m.DetallesVentaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'crear-pago-venta',
    loadComponent: () => import('./pages/pagoVenta/crear-pago-venta/crear-pago-venta.page').then( m => m.CrearPagoVentaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-pago-venta',
    loadComponent: () => import('./pages/pagoVenta/editar-pago-venta/editar-pago-venta.page').then( m => m.EditarPagoVentaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'crear-gasto',
    loadComponent: () => import('./pages/gasto/crear-gasto/crear-gasto.page').then( m => m.CrearGastoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-gasto',
    loadComponent: () => import('./pages/gasto/editar-gasto/editar-gasto.page').then( m => m.EditarGastoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'expediente',
    loadComponent: () => import('./pages/expediente/expediente/expediente.page').then( m => m.ExpedientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-expediente',
    loadComponent: () => import('./pages/expediente/editar-expediente/editar-expediente.page').then( m => m.EditarExpedientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'clausulas',
    loadComponent: () => import('./pages/expediente/clausulas/clausulas.page').then( m => m.ClausulasPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'dashboard-cliente',
    loadComponent: () => import('./pages/cliente/dashboard-cliente/dashboard-cliente.page').then( m => m.DashboardClientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'crear-cliente',
    loadComponent: () => import('./pages/cliente/crear-cliente/crear-cliente.page').then( m => m.CrearClientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'editar-cliente',
    loadComponent: () => import('./pages/cliente/editar-cliente/editar-cliente.page').then( m => m.EditarClientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'detalles-cliente',
    loadComponent: () => import('./pages/cliente/detalles-cliente/detalles-cliente.page').then( m => m.DetallesClientePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'dashboard-vehiculo',
    loadComponent: () => import('./pages/vehiculo/dashboard-vehiculo/dashboard-vehiculo.page').then( m => m.DashboardVehiculoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'crear-vehiculo',
    loadComponent: () => import('./pages/vehiculo/crear-vehiculo/crear-vehiculo.page').then( m => m.CrearVehiculoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'editar-vehiculo',
    loadComponent: () => import('./pages/vehiculo/editar-vehiculo/editar-vehiculo.page').then( m => m.EditarVehiculoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'detalles-vehiculo',
    loadComponent: () => import('./pages/vehiculo/detalles-vehiculo/detalles-vehiculo.page').then( m => m.DetallesVehiculoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'dashboard-chofer',
    loadComponent: () => import('./pages/chofer/dashboard-chofer/dashboard-chofer.page').then( m => m.DashboardChoferPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'crear-chofer',
    loadComponent: () => import('./pages/chofer/crear-chofer/crear-chofer.page').then( m => m.CrearChoferPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'editar-chofer',
    loadComponent: () => import('./pages/chofer/editar-chofer/editar-chofer.page').then( m => m.EditarChoferPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'detalles-chofer',
    loadComponent: () => import('./pages/chofer/detalles-chofer/detalles-chofer.page').then( m => m.DetallesChoferPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor'] }
  },
  {
    path: 'dashboard-usuario',
    loadComponent: () => import('./pages/usuario/dashboard-usuario/dashboard-usuario.page').then( m => m.DashboardUsuarioPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'crear-usuario',
    loadComponent: () => import('./pages/usuario/crear-usuario/crear-usuario.page').then( m => m.CrearUsuarioPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'editar-usuario',
    loadComponent: () => import('./pages/usuario/editar-usuario/editar-usuario.page').then( m => m.EditarUsuarioPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },
  {
    path: 'detalles-usuario',
    loadComponent: () => import('./pages/usuario/detalles-usuario/detalles-usuario.page').then( m => m.DetallesUsuarioPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'configuracion',
    loadComponent: () => import('./pages/configuracion/configuracion.page').then( m => m.ConfiguracionPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'mapa',
    loadComponent: () => import('./pages/mapa/mapa.page').then( m => m.MapaPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'expediente-crear',
    loadComponent: () => import('./pages/expediente/expediente-crear/expediente-crear.page').then( m => m.ExpedienteCrearPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'cotizador-rapido',
    loadComponent: () => import('./pages/cotizador-rapido/cotizador-rapido.page').then( m => m.CotizadorRapidoPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['Admin', 'Supervisor', 'Agente'] }
  },

];
